import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const getOwnerId = (owner) => {
  if (owner && typeof owner === 'object') return owner.id ?? null;
  return owner ?? null;
};

const TIME_FORMATS = ['H:mm', 'HH:mm', 'H:mm:ss', 'HH:mm:ss'];

const parseTime = (value) => dayjs(String(value ?? '').trim(), TIME_FORMATS, true);

export function normalizeToHHmm(value) {
  const parsedTime = parseTime(value);
  return parsedTime.isValid() ? parsedTime.format('HH:mm') : '';
}

export function isTimeInRange(value, startHour, endHour) {
  const parsedTime = parseTime(value);
  if (!parsedTime.isValid()) return false;

  const hour = parsedTime.hour();
  return hour >= startHour && hour <= endHour;
}

export function getSelectedOwnerIds(owners) {
  const uniqueIds = new Set();

  (Array.isArray(owners) ? owners : []).forEach((owner) => {
    const id = getOwnerId(owner);
    if (id === null || id === undefined || String(id).trim() === '') return;
    uniqueIds.add(String(id));
  });

  return Array.from(uniqueIds);
}

export function buildCalendarEventPayloads(event, owners) {
  return getSelectedOwnerIds(owners).map((owner) => ({
    ...event,
    owner,
  }));
}
